(function () {
  var STATE_SEL = '[data-amc-conditional-addons-state]';
  var BANNER_ATTR = 'data-amc-addon-checkout-block';
  var MSG_ATTR = 'data-amc-addon-atc-msg';
  var DISABLED_BY_US = 'data-amc-addon-disabled-by-us';
  var removing = false;

  function rootPath() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function parseNode(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function readState() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(STATE_SEL));
    if (!nodes.length) return null;

    var cartState =
      parseNode(document.querySelector('#CartDrawer ' + STATE_SEL)) ||
      parseNode(document.querySelector('#main-cart-items ' + STATE_SEL));

    var pageGate = null;
    var fallback = null;
    for (var i = 0; i < nodes.length; i++) {
      var parsed = parseNode(nodes[i]);
      if (!parsed) continue;
      if (!fallback) fallback = parsed;
      if (parsed.productGate && parsed.productGate.isAddon) {
        pageGate = parsed.productGate;
        if (!fallback.message && parsed.productGate.message) fallback = parsed;
      }
    }

    var base = cartState || fallback;
    if (!base) return null;

    var out = {
      map: base.map || {},
      parentTagsPresent: (cartState && cartState.parentTagsPresent) || base.parentTagsPresent || [],
      orphanKeys: (cartState && cartState.orphanKeys) || [],
      orphanMessage: base.orphanMessage || '',
      checkoutBlockMessage: base.checkoutBlockMessage || '',
      productGate: pageGate,
    };

    if (out.productGate && out.productGate.isAddon) {
      var required = out.productGate.requiredTags || [];
      var present = out.parentTagsPresent || [];
      var allowed = false;
      for (var r = 0; r < required.length; r++) {
        if (present.indexOf(required[r]) !== -1) {
          allowed = true;
          break;
        }
      }
      out.productGate = {
        isAddon: true,
        allowed: allowed,
        message: out.productGate.message || '',
        requiredTags: required,
      };
    }

    return out;
  }

  function earliestAnchor(form, btn) {
    var payment =
      form.querySelector('[id^="x-payment-button-"]') ||
      form.querySelector('.payment-button-container');
    if (btn && payment) {
      return btn.compareDocumentPosition(payment) & Node.DOCUMENT_POSITION_FOLLOWING ? btn : payment;
    }
    return btn || payment || null;
  }

  function setPaymentBlocked(form, blocked) {
    var payment =
      form.querySelector('[id^="x-payment-button-"]') ||
      form.querySelector('.payment-button-container');
    if (!payment) return;
    payment.classList.toggle('amc-addon-payment-blocked', blocked);
    payment.setAttribute('aria-hidden', blocked ? 'true' : 'false');
    if (blocked) {
      payment.style.display = 'none';
    } else {
      payment.style.display = '';
    }
  }

  function applyProductGate(state) {
    var gate = state && state.productGate;
    if (!gate || !gate.isAddon) return;

    var forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    forms.forEach(function (form) {
      if (form.closest('[data-wcf-root], [data-amc-shop-wizard], .wcf-root')) return;

      var btn = form.querySelector('[name="add"], button[type="submit"]');
      var isSticky = !!(btn && btn.id && btn.id.indexOf('sticky') !== -1);
      var msg = form.querySelector('[' + MSG_ATTR + ']');
      var showMessage = !!btn && !isSticky;

      if (!gate.allowed) {
        if (btn) {
          if (!btn.disabled) btn.setAttribute(DISABLED_BY_US, 'true');
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
        }
        form.setAttribute('data-amc-addon-blocked', 'true');
        setPaymentBlocked(form, true);

        if (showMessage) {
          var anchor = earliestAnchor(form, btn);
          if (!msg) {
            msg = document.createElement('p');
            msg.setAttribute(MSG_ATTR, '');
            msg.setAttribute('role', 'status');
            msg.style.cssText = 'margin:0 0 8px;font-size:14px;line-height:1.4;color:#991b1b;';
            if (anchor && anchor.parentNode) anchor.insertAdjacentElement('beforebegin', msg);
            else form.insertAdjacentElement('afterbegin', msg);
          } else if (anchor && msg.nextElementSibling !== anchor) {
            anchor.insertAdjacentElement('beforebegin', msg);
          }
          msg.textContent = gate.message || '';
        } else if (msg) {
          msg.remove();
        }
      } else {
        if (btn && btn.getAttribute(DISABLED_BY_US) === 'true') {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
          btn.removeAttribute(DISABLED_BY_US);
        }
        form.removeAttribute('data-amc-addon-blocked');
        setPaymentBlocked(form, false);
        if (msg) msg.remove();
      }
    });
  }

  function showCheckoutBanner(message) {
    var text = message || '';
    var targets = [document.getElementById('CartDrawer'), document.getElementById('main-cart-items')].filter(Boolean);
    targets.forEach(function (root) {
      var banner = root.querySelector('[' + BANNER_ATTR + ']');
      if (!banner) {
        banner = document.createElement('div');
        banner.setAttribute(BANNER_ATTR, '');
        banner.setAttribute('role', 'alert');
        banner.style.cssText =
          'margin:0 0 12px;padding:12px 14px;border-radius:10px;background:#fef2f2;color:#991b1b;border:1px solid #fecaca;font-size:14px;line-height:1.45;';
        var anchor =
          root.querySelector('.footer-cart-drawer-mobile') ||
          root.querySelector('.cart__footer') ||
          root.querySelector('form[action*="cart"]') ||
          root.firstElementChild;
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(banner, anchor);
        else root.prepend(banner);
      }
      banner.textContent = text;
      banner.hidden = false;
    });
    var helper = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
    if (helper) {
      helper.amcAddonCheckoutBlocked = true;
      helper.amcAddonCheckoutBlockMessage = text;
    }
  }

  function hideCheckoutBanner() {
    document.querySelectorAll('[' + BANNER_ATTR + ']').forEach(function (el) {
      el.hidden = true;
    });
    var helper = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
    if (helper) {
      helper.amcAddonCheckoutBlocked = false;
      helper.amcAddonCheckoutBlockMessage = '';
    }
  }

  function sectionIds() {
    var helper = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
    if (helper && typeof helper.getSectionsToRender === 'function') {
      return helper.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }
    return ['cart-drawer'];
  }

  function removeOrphans(state) {
    var keys = (state && state.orphanKeys) || [];
    if (!keys.length || removing) {
      if (!keys.length) hideCheckoutBanner();
      return Promise.resolve(false);
    }

    removing = true;
    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    var body = { updates: updates, sections: sectionIds() };
    return fetch(rootPath() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        var helper = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
        if (helper && typeof helper.reRenderSections === 'function' && response.sections) {
          helper.reRenderSections(response.sections);
        }
        if (helper && typeof response.item_count === 'number') {
          helper.currentItemCount = response.item_count;
        }
        // Keep removing=true until after the synthetic event so we don't re-enter.
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        removing = false;
        hideCheckoutBanner();
        applyProductGate(readState());
        return true;
      })
      .catch(function () {
        removing = false;
        showCheckoutBanner((state && state.checkoutBlockMessage) || '');
        return false;
      });
  }

  function onCartChanged() {
    if (removing) return;
    var state = readState();
    if (!state) return;
    applyProductGate(state);
    removeOrphans(state).then(function (didRemove) {
      if (didRemove) return;
      var next = readState();
      if (next && next.orphanKeys && next.orphanKeys.length) {
        showCheckoutBanner(next.checkoutBlockMessage || '');
      } else {
        hideCheckoutBanner();
        applyProductGate(next || state);
      }
    });
  }

  function interceptAdd(e) {
    var state = readState();
    var gate = state && state.productGate;
    if (!gate || !gate.isAddon || gate.allowed) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var form = t.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    if (form.closest('[data-wcf-root], [data-amc-shop-wizard], .wcf-root')) return;
    e.preventDefault();
    e.stopPropagation();
    applyProductGate(state);
  }

  function interceptCheckout(e) {
    var helper = window.Alpine && Alpine.store && Alpine.store('xCartHelper');
    if (helper && helper.amcAddonCheckoutBlocked) {
      e.preventDefault();
      e.stopPropagation();
      showCheckoutBanner(helper.amcAddonCheckoutBlockMessage || '');
      return;
    }
    var state = readState();
    if (state && state.orphanKeys && state.orphanKeys.length) {
      e.preventDefault();
      e.stopPropagation();
      showCheckoutBanner(state.checkoutBlockMessage || '');
    }
  }

  document.addEventListener('click', interceptAdd, true);
  document.addEventListener('submit', interceptAdd, true);
  document.addEventListener('eurus:cart:items-changed', onCartChanged);

  function bootAddons() {
    onCartChanged();
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest('[name="checkout"], a[href*="/checkout"], [href="/checkout"]')) {
          interceptCheckout(e);
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAddons);
  } else {
    bootAddons();
  }
})();
